import { cva } from 'class-variance-authority'

export const illustrationVariants = cva('inline-block shrink-0', {
  variants: {
    size: {
      big: null,
      medium: null,
      small: null,
    },
  },
  defaultVariants: {
    size: 'big',
  },
})
